import * as React from "react";
import CloseIcon from "@mui/icons-material/Close";
import "./tag.css";

interface TagProps {
  label: string;
  tabIndex?: number;
  onDelete: () => void;
}

export const Tag = (props: TagProps) => {
  const { label, onDelete, ...other } = props;
  return (
    <div {...other} className="container">
      <span className="tagLabel">{label}</span>
      <CloseIcon onClick={onDelete} className="tagIcon" />
    </div>
  );
};
